import { useParams, Navigate, Link } from "react-router-dom";
import { PAGES, LAST_UPDATED } from "@/content/legal";
import PublicFooter from "@/components/PublicFooter";
import { Logo } from "@/components/Logo";

function Section({ s }) {
  if (s.group) {
    return <h2 className="mt-12 mb-2 text-xs font-semibold uppercase tracking-[0.14em] text-[#968F85]">{s.h}</h2>;
  }
  return (
    <section className="mt-8">
      {s.h && <h2 className="text-lg font-semibold tracking-tightish text-[#292827]">{s.h}</h2>}
      {s.price && <p className="mt-1 text-[15px] font-medium text-[#292827]">{s.price}</p>}
      {s.body?.map((p, i) => (
        <p key={i} className="mt-3 text-[15px] text-[#6E675C] leading-relaxed">{p}</p>
      ))}
      {s.list && (
        <ul className="mt-3 space-y-2">
          {s.list.map((li, i) => (
            <li key={i} className="flex gap-3 text-[15px] text-[#6E675C] leading-relaxed">
              <span className="mt-2 h-1 w-1 rounded-full bg-[#292827] shrink-0" />{li}
            </li>
          ))}
        </ul>
      )}
      {s.note && (
        <p className="mt-3 rounded-xl bg-[#E9EAEC] px-4 py-3 text-[13px] text-[#6E675C] leading-relaxed">{s.note}</p>
      )}
    </section>
  );
}

export default function InfoPage() {
  const { slug } = useParams();
  const page = PAGES[slug];
  if (!page) return <Navigate to="/" replace />;

  return (
    <div className="min-h-screen bg-white flex flex-col" data-testid={`info-page-${slug}`}>
      <header className="border-b border-[#E6E1D9]">
        <div className="max-w-3xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="text-[19px] font-semibold tracking-tightish text-[#292827]">Creatori</Link>
          <Link to="/" className="text-sm text-[#6E675C] hover:text-[#292827] transition-colors">Etusivulle</Link>
        </div>
      </header>

      <main className="flex-1">
        <div className="max-w-3xl mx-auto px-6 py-14">
          <h1 className="text-4xl font-semibold tracking-display text-[#292827]">{page.title}</h1>
          {page.subtitle && <p className="mt-3 text-[17px] text-[#6E675C] leading-relaxed">{page.subtitle}</p>}
          <p className="mt-4 text-[13px] text-[#968F85]">Viimeksi päivitetty: {LAST_UPDATED}</p>
          <div className="mt-2">
            {page.sections.map((s, i) => <Section key={i} s={s} />)}
          </div>
        </div>
      </main>

      <PublicFooter />
    </div>
  );
}
